import React, { useEffect, useState } from 'react'
import profile from "../../Assets/Images/arch-icon.png"
import { useAuth } from '../../Context/AuthContext'
import { Link, useNavigate } from 'react-router-dom'

function Header({ pageTitle }) {
  const { setIsAuth, isUser, getUser } = useAuth()
  const navigate = useNavigate()
  const [openMenu, setOpenMenu] = useState(false)

  async function logOut() {
    setIsAuth(false)
    localStorage.removeItem('token')
    navigate("/Login")
  }

  useEffect(() => {
    getUser();
  }, []);

  return (
    <div className='flex items-center justify-between relative'>
      <div>
        <h1 className='text-[28px] font-[600] text-[#0966AE] font-[Cairo]'>{pageTitle}</h1>
      </div>

      <div className='flex justify-between items-center relative'>
        <div>
          <h1 className='text-[18px] text-[#000] font-[Cairo] pr-2'>{isUser?.name}</h1>
        </div>

        {/* صورة البروفايل */}
        <img
          src={profile}
          alt="profile"
          onClick={() => setOpenMenu(!openMenu)}
          className='w-[50px] h-[50px] object-cover rounded-full border border-gray-300 cursor-pointer'
        />

        {/* المنيو */}
        {openMenu && (
          <div className='absolute right-0 mt-2 w-44 bg-white shadow-lg rounded-xl border py-2'>
            <Link
              to={`/User/Profile`}
              className='block w-full text-right px-4 py-2 text-[#0966AE] hover:bg-gray-100'
              onClick={() => setOpenMenu(!openMenu)}
            >
              الملف الشخصى
            </Link>
            <button
              onClick={logOut}
              className='block w-full text-right px-4 py-2 text-red-600 hover:bg-gray-100'
            >
              تسجيل الخروج
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Header
